import React, { PureComponent } from 'react';

import { message as AntMessage, Popconfirm as AntPopconfirm } from 'antd';
import { services } from '@comall-backend-builder/core';
import { Button } from '@comall-backend-builder/components-basis';
import { errorHandle } from '../../services';

const api = services.api;
/**
 * 直播商品列表页 全部刷新
 */
export class LiveProductRefreshButton extends PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
        };
    }

    refesh = () => {
        if (this.state.loading) {
            return;
        }

        this.setState({ loading: true });

        const { entity } = this.props;
        api.get(
            {},
            { apiPath: '/live/products/refresh/all' }
        ).then(() => {
            this.setState({ loading: false });

            AntMessage.success('刷新成功');

            // 列表数据刷新
            entity.search({
                ...entity.params,
                ...entity.filters,
            });
        })
        .catch(errorHandle);
    };

    render() {
        const btnProps = Object.assign({}, this.props, {
            loading: this.state.loading
        });
        const confirmProps = {
            title: '确定要全部刷新吗？',
            okText: '确定',
            cancelText: '取消',
            onConfirm: this.refesh,
        };
        return (
            <AntPopconfirm {...confirmProps}>
                <Button {...btnProps} />
            </AntPopconfirm>
        );
    }
}
